<div class="row no-gutters row-eq-height product">
	<div class="col-lg-4 col-xl-4 col-md-12 master_image" *ngIf='cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(' + appService.getBaseServerAddress() + '/document_files/resize/1024x768/' + cartItem.target_info.master_image_item + ')'}">
		<img [src]="appService.getBaseServerAddress() + '/document_files/resize/1024x768/' + cartItem.target_info.master_image_item" />
	</div>
	<div class="col-lg-4 col-xl-4 col-md-12 master_image" *ngIf='!cartItem.target_info.master_image_item' [ngStyle]="{background: 'url(assets/img/1024x768.png)'}">
		<img src="assets/img/1024x768.png" />
	</div>
	<div class="col-lg-8 col-xl-8 col-md-12 cart-info">
		<h4>
			<span class="item-name">
				<a [routerLink]="['/d', appService.domainId, 'detail', 'trip_packages', cartItem.trip_package_id]">
					{{cartItem.target_info.display_name_item}}
				</a>
			</span>
		</h4>
        <div class="participants" *ngIf="cartItem.target_info.is_family">
           <span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
				  BIGLIETTO FAMIGLIA
			</span>
        </div>
		<div class="participants">
			<span class="adt" *ngIf='cartItem.trip_booking.participant_counters["ADT"]'>
				{{ cartItem.trip_booking.participant_counters['ADT'] }} X ADT
			</span>
			<span class="chd" *ngIf='cartItem.trip_booking.participant_counters["CHD"]'>
				{{ cartItem.trip_booking.participant_counters['CHD'] }} X CHD
			</span>
			<span class="inf" *ngIf='cartItem.trip_booking.participant_counters["INF"]'>
				{{ cartItem.trip_booking.participant_counters['INF'] }} X INF
			</span>
			<span class="snr" *ngIf='cartItem.trip_booking.participant_counters["SNR"]'>
				{{ cartItem.trip_booking.participant_counters['SNR'] }} X SNR
			</span>
		</div>
		<div class="tour-date">{{cartItem.date | date: 'dd/MM/yyyy'}}</div>
		<div class="item-name" *ngIf='cartItem.target_info.variation_name_item'>
			{{cartItem.target_info.variation_name_item}}
		</div>

		<!-- trip_booking_resources -->
		<ul class="trip_booking_resources">
			<ng-container *ngFor='let tripBookingResource of cartItem.trip_booking_resources'>
				<li>{{ tripBookingResource.trip_resource.description }} - <span class="price">{{ tripBookingResource.total_amount | currency:'EUR' }}</span></li>
			</ng-container>
		</ul>

		<div class="prices-item">
			<div [ngClass]="{'item-price': true, 'line-through': cartItem.target_info.total_price_item > cartItem.trip_booking.total_amount}">
				{{ cartItem.target_info.total_price_item | currency:'EUR' }}
			</div>
			<div class="discounted-price" *ngIf='cartItem.target_info.total_price_item > cartItem.trip_booking.total_amount'>
				{{ cartItem.trip_booking.total_amount | currency:'EUR' }}
			</div>
		</div>

		<div class="remove-item" (click)='cartService.removeItem(cartItem.id)'>
			{{'Rimuovi' | translate}}
		</div>
	</div>
</div>
